import { track } from "tracking/client";
import { Logger } from "lib/logger";

const log = Logger("components/IntersectionDelegate/handlers/experimentViewed");

export function trackExperimentViewed(flag: string, value: number): void {
  const key = `ExperimentViewed__${flag}__${value}`;

  if (sessionStorage?.getItem(key)) return;

  track({
    event: "Experiment Viewed",
    properties: {
      experiment_id: flag,
      experiment_variant: value
    }
  });

  sessionStorage.setItem(key, "1");
}

export const experimentViewed = (element: HTMLElement): void => {
  try {
    const { flag, variation } = element.dataset;

    if (!flag) {
      throw new TypeError(`Experiment Viewed: Element Missing [data-flag]`);
    }

    if (!variation) {
      throw new TypeError(
        `Experiment Viewed: Element Missing [data-variation]`
      );
    }

    trackExperimentViewed(flag, +variation);
  } catch (err) {
    log.error({ err }, `Failed to send experiment viewed event to Segment`);
  }
};
